export default __webpack_public_path__ + "static/media/arcgis-enterprice-launch-kit.d0d3445f.svg";